<div class="mat-modal-wrapper">
	<app-ehe-verification-modal
		(action)="actionFunction($event)"
		[title]="'Add Document'"
		[button1]="'Upload'"
		[button2]="'Cancel'">
		<form [formGroup]="uploadDocumentForm" class="uploadForm">
			<div class="row justify-content-center">
				<div class="col-md-12">
					<mat-form-field class="w-100">
						<mat-label>File Name</mat-label>
						<input matInput formControlName="filename" required />
						<mat-error>
							<app-error-message [control]="'filename'"></app-error-message>
						</mat-error>
					</mat-form-field>
				</div>

				<!-- Future feature -->
				<!-- <div class="col-md-8">
					<mat-form-field class="w-100">
						<mat-label>Category</mat-label>
						<input matInput formControlName="category" />
						<mat-error>
							<app-error-message [control]="'category'"></app-error-message>
						</mat-error>
					</mat-form-field>
				</div> -->

				<div class="col-md-12">
					<mat-form-field class="w-100">
						<mat-label>Description</mat-label>
						<input matInput formControlName="description" />
						<mat-error>
							<app-error-message [control]="'description'"></app-error-message>
						</mat-error>
					</mat-form-field>
				</div>
				<div class="col-md-12">
					<!-- true validation done within OtherDocumentsComponent, 'accept' is just for UI -->
					<input
						accept=".pdf ,image/png, image/jpg, image/jpeg, image/gif "
						placeholder="Browse"
						formControlName="fileBody"
						type="file"
						(change)="getFileDetails($event)"
						class="input-file"
						id="file" />
					<label for="file">{{ inputLabel }}</label>
					<app-error-message [control]="'fileBody'"></app-error-message>
				</div>
			</div>
		</form>
	</app-ehe-verification-modal>
</div>
